'use client';

import Image from 'next/image';
import Link from 'next/link';
import { motion } from 'framer-motion';

export function BannerSelling() {
  const text = 'Turn your car into cash — start\n selling today!'.split(' ');

  return (
    <section className='section-banner-selling'>
      <div className='container'>
        <div
          className='bg-[url(/images/home/footer-banner.png)] bg-no-repeat bg-center rounded-2xl
        flex flex-col items-end p-[30px_20px] md:p-[120px_100px] hover:shadow-2xl transition-all duration-500 relative
       before:w-full before:h-full before:absolute before:top-0 before:left-0
        before:transition-all before:duration-500 before:rounded-2xl before:bg-[#463928B2]/70'
        >
          <div
            className='relative text-right text-[2rem] md:text-[3rem] lg:text-[3.5rem]  text-background font-bold
            leading-none whitespace-pre-line sm:text-[2.5rem] xl:text-[4rem]'
          >
            {text.map((el, i) => (
              <motion.span
                initial={{ opacity: 0 }}
                whileInView={{
                  opacity: 1,
                  x: 0, // Slide in to its original position
                  transition: {
                    duration: 0.8,
                    delay: i / 8, // Animation duration
                  },
                }}
                viewport={{ once: false }}
                key={i}
              >
                {el}{' '}
              </motion.span>
            ))}
          </div>
          <Link
            href='/my-listings'
            className='relative font-bold rounded-[6px] bg-primary text-background uppercase
              flex items-center gap-4 md:gap-10 px-4 md:px-5 py-2 md:py-[0.75rem] mt-4 md:mt-6
              hover:text-background! hover:bg-primary-3'
          >
            <span>Looking to sell your car?</span>
            <Image src='/images/icon/plus-white.png' width={17} height={17} alt='' />
          </Link>
        </div>
      </div>
    </section>
  );
}
